var _circle, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEthLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#627EEA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.9961 14L29.7776 14.7293V35.8904L29.9961 36.1046L39.9937 30.2984L29.9961 14Z",
    fill: "#C0CBF6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9979 14L20 30.2984L29.9979 36.1046V25.8336V14Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9962 37.9614L29.873 38.1089V45.6468L29.9962 46.0001L39.9999 32.1582L29.9962 37.9614Z",
    fill: "#C0CBF6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9979 46V37.9613L20 32.1581L29.9979 46Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9963 36.116L39.9939 30.3098L29.9963 25.845V36.116Z",
    fill: "#8197EE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20 30.3097L29.9979 36.1159V25.8449L20 30.3097Z",
    fill: "#C0CBF6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthLogo);
export default __webpack_public_path__ + "static/media/eth_logo.b1488aa37fc96513ba635f6f63de74b6.svg";
export { ForwardRef as ReactComponent };